import React from 'react'
import { render } from 'react-dom'
import FlashMessage from '../components/atoms/FlashMessage'

const sendEmail = (templateParams, translations) => {
  fetch('/api/contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      name: templateParams.from_name,
      email: templateParams.from_email,
      phone: templateParams.phone,
      message: templateParams.message,
      checkInDate: templateParams.checkInDate,
      checkOutDate: templateParams.checkOutDate,
      company: templateParams.company || '',
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('request failed')
      }
      render(
        <FlashMessage message={translations.sent_successfully} success/>,
        document.body.appendChild(document.createElement('DIV'))
      )
    })
    .catch(() => {
      render(
        <FlashMessage message={translations.sent_fail}/>,
        document.body.appendChild(document.createElement('DIV'))
      )
    })
}

export default sendEmail
